import React, { useContext, useEffect, useState } from 'react'
import { getImages } from '../Const'
import { Link, useNavigate } from 'react-router-dom'
import { LeadsContext } from "../Context/LeadsContext";
import DropZoneBox from './DropZoneBox';
import DropZoneBoxImage from './DropZoneBoxImage';

const AdlMenu = ({ close, paramId, handleAdMenu, editingAppraisal, appraisalData, inProgress, titileStatus, showEtitleBox }) => {
    // console.log("paramId", paramId)
    const { setSelectedId, updateLeadDataMultiple, copySniperMonkeyLead, getLeads, selectLead, listDocuments, archiveLead } = useContext(LeadsContext);
    const navigate = useNavigate();

    const handleNavigation = (id) => {
        setSelectedId(id);
        window.open(`/appraisal-builder?lead_id=${id}`, "_blank");
    };
    const advanceReport = async () => {
        var values = {
            'id': appraisalData.id,
            'appraisal_stage': appraisalData.appraisal_stage == "InQueue" ? "InProgress" : "Completed",
            'lead_type': 'InPerson'
        }
        const response = await updateLeadDataMultiple(values);
        console.log(response);
        appraisalData.appraisal_stage = appraisalData.appraisal_stage == "InQueue" ? "InProgress" : "Completed";
        //close();
    };

    const copySMLead = async () => {
        console.log(appraisalData);

        const data = await copySniperMonkeyLead(appraisalData.id);

        if(data && data.success) {            
            close();
            alert("Lead added");
            const lead_data = await getLeads();
            if('lead_id' in data && data.lead_id) selectLead(data.lead_id);
        } else {
            alert("Error adding lead");
        }
    }

    const addToQueue = async () => {
        var values = {
            'id': appraisalData.id,
            'lead_type': 'InPerson',
            'appraisal_stage': 'InQueue',
            'appointment_date': null,
            'no_show':0
        }
        const response = await updateLeadDataMultiple(values);
        console.log(response);

        close();
    }

    const removeAppointment = async () => {
        var values = {
            'id': appraisalData.id,
            'lead_type': appraisalData.lead_type,
            'appraisal_stage': appraisalData.appraisal_stage,
            'no_show':1
        }
        const response = await updateLeadDataMultiple(values);
        console.log(response);

        close();
    }

    const deleteAppraisal = async () => {
        archiveLead(appraisalData);
        close();
    }

    const renderActions = () => (
        <>
            {appraisalData.appointment_date && !appraisalData.no_show && 
                <button className="nav-link" onClick={addToQueue}>
                    <span className='adl-icon'>
                        <img src={getImages('advance-report.png')} />
                    </span>
                    Add to Queue
                </button>
            }

            <button
                className={`nav-link ${editingAppraisal ? 'active' : ''}`}
                onClick={handleAdMenu}
            >
                <span className='adl-icon'>
                    <img src={getImages('edit-appraisal.png')} />
                </span>
                {appraisalData.appraisal_stage == "InQueue" ? "Begin" : "Edit"} Appraisal
            </button>

            {!inProgress && (
                <button
                    type="button"
                    className="nav-link"
                    onClick={() => handleNavigation(paramId)}
                >
                    <span className='adl-icon'>
                        <img src={getImages('print-report.png')} />
                    </span>
                    Print Report
                </button>
            )}

            {/*<button className="nav-link" onClick={advanceReport}>
                <span className='adl-icon'>
                    <img src={getImages('advance-report.png')} />
                </span>
                Advance Report
            </button>*/}

            {!inProgress && (
                <Link
                    to={"/appraisal-builder?lead_id=" + appraisalData.id + "&email"}
                    target="_blank"
                    className="nav-link"
                >
                    <span className='adl-icon'>
                        <img src={getImages('email-to-customer.png')} />
                    </span>
                    Email to Customer
                </Link>
            )}

            {appraisalData.appointment_date && !appraisalData.no_show && 
                <button className="nav-link" onClick={removeAppointment}>
                    <span className='adl-icon'>
                        <img src={getImages('advance-report.png')} />
                    </span>
                    Remove Appointment
                </button>
            }

            {(appraisalData.appraisal_stage == "InQueue" || appraisalData.appraisal_stage == "InProgress") && <button className="nav-link" onClick={deleteAppraisal}>
                <span className='adl-icon'>
                    <img src={getImages('delete-apprasial.png')} />
                </span>
                Delete Appraisal
            </button>}
        </>
    );

    const renderSMActions = () => (
        <>
            <button className="nav-link" onClick={copySMLead}>
                <span className='adl-icon'>
                    <img src={getImages('advance-report.png')} />
                </span>
                Copy Appraisal
            </button>
        </>
    );
    const [uploadedImages, setUploadedImages] = useState([]);

    const [documentData,setDocumentData] = useState([]);

    const getDocuments = async (lead_id) => {
        const data = await listDocuments(lead_id);

        setDocumentData(data);
    
    }

    useEffect(() => {
        if(appraisalData && appraisalData.id) getDocuments(appraisalData.id);
    },[appraisalData]);

    return (appraisalData && Object.keys(appraisalData) != 0 && 
        <>
            <div className='d-none d-lg-block'>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        {appraisalData.is_snipermonkey ? renderSMActions() : renderActions()}
                    </div>
                </nav>
            </div>
            <div className="dropdown d-lg-none ad-dropdown mb-3">
                <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                </button>
                <ul className="dropdown-menu">
                    {appraisalData.is_snipermonkey ? renderSMActions() : renderActions()}
                </ul>
            </div> <div className='mt-4'>
                {(
                    (showEtitleBox
                        ? (showEtitleBox === "Paper Title" || showEtitleBox === "E-Title")
                        : (appraisalData.titlestatus === "Paper Title" || appraisalData.titlestatus === "E-Title")
                    ) && (
                        <>
                            <div className='adr-value font-1em text-uppercase'>E-Title</div>
                            <div className='row gx-2'>
                                <div className='col-md-6 mb-3'>
                                    <a href={getImages('pdf/ETITLE_9-10-2024.pdf')} download className='et-box d-block'>
                                        <div className='text-center mb-3'><img src={getImages('pdf.svg')} /></div>
                                        <div className='text-center xs-title font-12 text-gray fw-500'>ETITLE</div>
                                    </a>
                                </div>
                                <div className='col-md-6 mb-3'>
                                    <a href={getImages('pdf/ETITLE_AND_03-2024.pdf')} download className='et-box d-block'>
                                        <div className='text-center mb-3'><img src={getImages('pdf.svg')} /></div>
                                        <div className='text-center xs-title font-12 text-gray fw-500'>ETITLE (AND)</div>
                                    </a>
                                </div>
                            </div>
                        </>
                    )
                )}
                {(
                    (showEtitleBox
                        ? (showEtitleBox === "Financed" || showEtitleBox === "Lease")
                        : (appraisalData.titlestatus === "Financed" || appraisalData.titlestatus === "Lease")
                    ) && (
                        <>
                            <div className='adr-value font-1em text-uppercase'>Payoff</div>
                            <div className='row gx-2'>
                                <div className='col-md-6 mb-3'>
                                    <a href={getImages('pdf/PAYOFF_3-12-2025.pdf')} download className='et-box d-block'>
                                        <div className='text-center mb-3'><img src={getImages('pdf.svg')} /></div>
                                        <div className='text-center xs-title font-12 text-gray fw-500'>PAYOFF</div>
                                    </a>
                                </div>
                                <div className='col-md-6 mb-3'>
                                    <a href={getImages('pdf/PAYOFF_AND_03-2024.pdf')} download className='et-box d-block'>
                                        <div className='text-center mb-3'><img src={getImages('pdf.svg')} /></div>
                                        <div className='text-center xs-title font-12 text-gray fw-500'>PAYOFF (AND)</div>
                                    </a>
                                </div>
                            </div>
                        </>
                    )
                )}
                {!appraisalData.is_snipermonkey && (
                    <div className='d-block'>
                        {documentData && <DropZoneBox leadId={appraisalData.id} showUpload={editingAppraisal} documentData={documentData} />}
                    </div>
                )}
                <hr className='cs-hr mt-4'/>
                {documentData && <DropZoneBoxImage 
                    leadId={appraisalData.id} 
                    showUpload={editingAppraisal} 
                    onChange={setUploadedImages} 
                    uploadedImages={uploadedImages}
                    documentData={documentData}
                    leadPhotos={!appraisalData?.Vehicle_Photos || appraisalData?.Vehicle_Photos == "" ? [] : appraisalData?.Vehicle_Photos?.split(',')}
                />}
            </div>
        </>
    )
}

export default AdlMenu